import {
  AIRecommendation,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
export const AI_RECOMMENDATION_QUERY_KEY = 'alarm_ai_recommendation';

export function useAIRecommendation(
  alarmId: string,
  product?: UnifiedMonitoringProduct,
  refetchInterval?: number
) {
  const url = `/v2/orm/ai_outputs_location_alarm/?${
    product === UnifiedMonitoringProduct.SCAN ? 'alarm_group_id' : 'alarm_id'
  }=${alarmId}`;

  const request = new Request(url);

  return useAuthenticatedRequest<AIRecommendation[]>(request, {
    queryKey: [AI_RECOMMENDATION_QUERY_KEY, alarmId],
    refetchInterval: refetchInterval,
    responseModifier: async (response) => {
      const respJson = await response.json();
      const payload = respJson.payload;
      let resp = [];
      if (Array.isArray(payload)) {
        resp = [...payload];
      } else {
        resp = [payload];
      }
      return resp;
    },
  });
}

export default useAIRecommendation;
